import { Quote, Star, ExternalLink } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const Reviews = () => (
    <section id="reviews" data-testid="reviews-section" className="bg-mist py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <SectionHeading
                number="07"
                eyebrow="Patient Reviews"
                title="Words From Our"
                accent="Patients"
                sub="Verified patient reviews from Google will appear here."
            />
            <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
                {[0, 1, 2].map((i) => (
                    <Reveal key={i} delay={i * 0.1}>
                        <figure
                            data-testid={`review-placeholder-${i}`}
                            className="flex h-full flex-col rounded-3xl border border-dashed border-teal-700/30 bg-white p-8"
                        >
                            <div className="flex items-center justify-between">
                                <Quote className="h-8 w-8 text-teal-accent/50" />
                                <span className="flex gap-0.5 text-teal-600/40">
                                    {Array.from({ length: 5 }).map((_, s) => (
                                        <Star key={s} className="h-4 w-4" />
                                    ))}
                                </span>
                            </div>
                            <blockquote className="mt-6 flex-1 font-display text-xl font-light italic leading-relaxed text-ink/60">
                                “Add verified patient review here.”
                            </blockquote>
                            <figcaption className="mt-6 border-t border-dashed border-ink/10 pt-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
                                Verified Patient · Google Review
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2} className="mt-12 text-center">
                <button
                    data-testid="view-google-reviews-btn"
                    className="inline-flex items-center gap-2 rounded-full border border-ink/20 bg-white px-8 py-4 text-sm font-bold text-ink transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-teal-600 hover:bg-mist"
                >
                    View Google Reviews
                    <ExternalLink className="h-4 w-4 text-teal-accent" />
                </button>
            </Reveal>
        </div>
    </section>
);
